import { ReactNode } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import SearchInput from "components/SearchInput";
import { SEARCH_PLACEHOLDERS } from "constants/searchPlaceholders";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";
import DesktopView from "components/Mobile/DesktopView";

import { FILTERS_ORDER_SETTINGS_KEY } from "./constants";
import TemplatesUpSell from "../TemplatesWorkbench/UpSell";

type TemplatesMarketplacePageLayoutProps = {
  children?: ReactNode;
  titleId: string;
  showUpSell?: boolean;
};

const TemplatesMarketplacePageLayout = ({
  children,
  titleId,
  showUpSell,
}: TemplatesMarketplacePageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);

  useTitle(`Templates · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderWrapper>
          <ViewHeaderTitle id={titleId}>Templates</ViewHeaderTitle>
        </ViewHeaderWrapper>

        <ViewHeaderWrapper direction="row">
          <SearchInput
            placeholder={SEARCH_PLACEHOLDERS.TEMPLATES}
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
          />

          <DesktopView>
            <DocumentationIconButton
              href={getDocsUrl("/concepts/template/deployments")}
              tooltipText="Go to template documentation"
            />
          </DesktopView>
        </ViewHeaderWrapper>
      </ViewHeader>

      {showUpSell ? <TemplatesUpSell /> : children}
    </>
  );
};

export default TemplatesMarketplacePageLayout;
